export default __webpack_public_path__ + "static/media/no-eye-white.824ca7ce.svg";